<script setup lang="ts">
import type { ResourceList, Section } from '@/models'
import { ref, toRefs, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import PaginatedList from '../PaginatedList.vue'
import ResourceItem from '@/components/cms/ResourceItem.vue'

const messages = {}

const { t } = useI18n({ messages })

const props = defineProps({
  section: {
    type: Object as PropType<Section>,
    default: () => {},
  },
})
const propRefs = toRefs(props)
// Create a local (typecast) reference to the data
const resourceList = propRefs.section.value as ResourceList

const selectedItem = ref(resourceList.resources[0])
</script>

<template>
  <div class="border-2 border-solid border-blue-600">
    <p class="text-blue-600">Resource List Section</p>
    <h1>{{ t('open') }}</h1>
    <div class="flex flex-col" v-if="resourceList.resources.length">
      <PaginatedList
        :items="resourceList.resources"
        :selected="selectedItem"
        :items-per-page="resourceList.itemsPerPage ?? 2"
        @update:selected="(item) => (selectedItem = item)"
      >
        <template #item="{ item, isSelected }">
          <ResourceItem :resource="item" :isSelected="isSelected"></ResourceItem>
        </template>
      </PaginatedList>
    </div>
  </div>
</template>
